import { ITileData } from 'apps/placeme/src/features/Analyse/slice/@types/ITileData'
import { ReactNode } from 'react'
import { AttractivenessValue, MapFeature } from '../../Potential/Attractiveness/@types/IAttractivenessTileData'

export interface IAlabAttractivenessResponseValue {
  attractiveness: {
    attractiveness: AttractivenessValue
    percentile?: number
    catchmentId: string
    map: {
      features: MapFeature[]
    }
    settings: {
      market: string
    }
  }
}

export interface IAlabAttractivenessTileData extends ITileData {
  value: IAlabAttractivenessResponseValue
}

export interface AlabAttractivenessFormState {
  market: string | null
  [key: string]:
  | boolean
  | string
  | string[]
  | null
  | undefined
}

export interface IAlabAttractivenessTileBody {
  coordinates: {
    lat: number
    lng: number
  }
  reportId: string
}

export type FormFieldValue =
  | string
  | boolean
  | string[]
  | null

export const AlabAttractivenessFormFields = {
  market: 'market',
} as const

export interface FormElement {
  formStateElement:
  | string
  | number
  | boolean
  | string[]
  | null
  | undefined
  inputKey: typeof AlabAttractivenessFormFields[keyof typeof AlabAttractivenessFormFields]
  options: {
    value: string | number | boolean
    label?: string
  }[]
  title: string
  width?: string
  multi?: boolean
  componentType?: 'checkbox' | 'dropdown' | 'multi-tiles'
  sectionTitle?: string
  sectionDescription?: string | ReactNode
}

export interface AlabAttractivenessFormDataObject {
  formElementData: FormElement[]
}
